

















































import { computed, defineComponent, ref } from "@vue/composition-api";
import { format } from "date-fns";
import { MassMessageStat } from "@scrile/api-provider/dist/api/MassMessageStat";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseImage from "@/components/BaseImage";
import FormatMoney from "@/components/FormatMoney";
import UnlockedModalView from "../UnlockedModalView";

export default defineComponent({
  name: "MassMessageStatItem",
  components: { UnlockedModalView, BaseImage, FormatMoney },
  props: {
    data: { type: Object as () => MassMessageStat, required: true },
  },
  setup(props) {
    const showUnlocked = ref<boolean>(false);
    const textContainer = ref<HTMLElement | null>(null);
    const showFullText = ref<boolean>(false);
    const date = computed(() => {
      return format(new Date(props.data.time), "MM/dd/yy");
    });
    const time = computed(() => {
      return format(new Date(props.data.time), "hh:mm a");
    });
    const content = computed(() => {
      if (props.data.urlPart && props.data.metadata) {
        return props.data.metadata.contentType.includes("image")
          ? MediaFilesController.getImageThumbnail(props.data.urlPart, 72)
          : MediaFilesController.getVideoThumbnail(props.data.urlPart, 72);
      } else return null;
    });
    const action = computed(() => {
      if (textContainer.value) {
        return (
          textContainer.value.scrollWidth > textContainer.value.offsetWidth ||
          textContainer.value.scrollHeight > textContainer.value.offsetHeight
        );
      } else return false;
    });
    const unlocked = computed(() => props.data.purchasedMessageIds.length);
    return { textContainer, date, time, content, showFullText, action, showUnlocked, unlocked };
  },
});
